import CandidateProjects from './CandidateProjects.container';

export default CandidateProjects;
